(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1961],{

/***/ 23493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(23279),
    isObject = __webpack_require__(13218);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 96936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15722);



var HtmlEmbed = function(props) {
    var createMarkup = function(content) {
        return {
            __html: content
        };
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: props.className,
        children: [
            props.html && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dangerouslySetInnerHTML: createMarkup(props.html)
            }),
            props.script && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: _lib_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setDangerousHtml.bind */ .RR.bind(null, props.script)
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (HtmlEmbed);


/***/ }),

/***/ 51961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ContentEditorView; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/ContentEditorView/Section.js




var Section = function(props) {
    var sectionClass = classnames_default()({
        "u-border-b-dotted": props.borderBottom,
        "u-border-t-dotted": props.borderTop,
        "u-space-mb-10 u-space-mt-10": props.verticalMargin,
        "u-space-pt-10 u-space-pb-10": props.verticalPadding,
        "u-space-p-10": props.fullPadding,
        "Content-children-inherit": props.color
    });
    var sectionStyles = {
        backgroundColor: props.bgColor && props.bgColor.length > 0 ? props.bgColor : null,
        color: props.color && props.color.length > 0 ? props.color : null
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: sectionClass,
        style: sectionStyles,
        children: props.children && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentEditorView_ContentEditorComponent, {
            content: props.children
        })
    }));
};
/* harmony default export */ var ContentEditorView_Section = (Section);

;// CONCATENATED MODULE: ./components/ContentEditorView/Medium.js




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var Medium = function(props) {
    var _obj;
    var mediumClass = classnames_default()((_obj = {}, _defineProperty(_obj, "u-text-align-".concat(props.align), props.align && props.align !== "left"), _defineProperty(_obj, "u-border-b-dotted", props.borderBottom), _defineProperty(_obj, "u-border-t-dotted", props.borderTop), _defineProperty(_obj, "u-space-mb-10 u-space-mt-10", props.verticalMargin), _defineProperty(_obj, "u-space-pt-10 u-space-pb-10", props.verticalPadding), _defineProperty(_obj, "u-space-p-10", props.fullPadding), _defineProperty(_obj, "Content-children-inherit", props.color), _obj));
    var mediumStyles = {
        backgroundColor: props.bgColor && props.bgColor.length > 0 ? props.bgColor : null,
        color: props.color && props.color.length > 0 ? props.color : null
    };
    var createMarkup = function(content) {
        return {
            __html: content
        };
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: mediumClass,
        style: mediumStyles,
        children: [
            props.html && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "Cms",
                dangerouslySetInnerHTML: createMarkup(props.html)
            }),
            props.children && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentEditorView_ContentEditorComponent, {
                content: props.children
            })
        ]
    }));
};
/* harmony default export */ var ContentEditorView_Medium = (Medium);

;// CONCATENATED MODULE: ./components/ContentEditorView/YouTube.js


var YouTube = function(props) {
    if (props.video_id) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "u-embed u-embed--16p9",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                src: "https://www.youtube.com/embed/".concat(props.video_id),
                frameBorder: "0",
                allowFullScreen: true
            })
        }));
    }
    // No data
    return null;
};
/* harmony default export */ var ContentEditorView_YouTube = (YouTube);

// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
;// CONCATENATED MODULE: ./components/ContentEditorView/Image.js




function Image_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Image_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ref = (0,config["default"])(), settings = ref.publicRuntimeConfig.settings;
var ImageTag = function(props) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("img", {
        src: props.src,
        alt: props.title,
        width: props.width,
        height: props.height,
        className: props.className
    });
};
var Image = function(props) {
    var imageClassNames = classnames_default()({
        "u-text-align-center": props.alignCenter
    });
    var imageClass = "".concat(props.classNames || "", " ").concat(imageClassNames);
    var imageProps = {
        alt: props.title,
        width: props.width && props.width.length > 0 ? props.width : null,
        height: props.height && props.height.length > 0 ? props.height : null,
        className: props.alignCenter ? "u-display-iblock u-text-vertical-middle" : ""
    };
    if (props.extUrl === "" && props.picked.length > 0 && props.picked[0].path && props.picked[0].name) {
        // TODO: THIS IS NOT RIGHT!
        // Check config out
        // this line --> imageProps.src = `${config.imageServer}${parent.content.picked[0].path}${parent.content.picked[0].name}`;
        // imageProps.src = "https://via.placeholder.com/200x300";
        imageProps.src = "".concat(settings.cdn).concat(props.picked[0].path).concat(props.picked[0].name);
    } else {
        imageProps.src = props.extUrl;
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: imageClass,
        children: props.linkUrl && props.linkUrl.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: props.linkUrl,
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageTag, _objectSpread({}, imageProps))
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageTag, _objectSpread({}, imageProps))
    }));
};
/* harmony default export */ var ContentEditorView_Image = (Image);

;// CONCATENATED MODULE: ./components/ContentEditorView/TextImage.js





function TextImage_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TextImage_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TextImage_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var TextImage_ref = (0,config["default"])(), _publicRuntimeConfig = TextImage_ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var isBricoStore = websiteName === "bricostore";
var Content = function(props) {
    var createMarkup = function(content) {
        return {
            __html: content
        };
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: props.classNames,
        children: props.html && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            dangerouslySetInnerHTML: createMarkup(props.html)
        })
    }));
};
var TextImage = function(props) {
    var containerClass = classnames_default()("flow-root", {
        "u-border-b-dotted": props.borderBottom,
        "u-border-t-dotted": props.borderTop,
        "u-space-mb-10 u-space-mt-10": props.verticalMargin,
        "u-space-pt-10 u-space-pb-10": props.verticalPadding,
        "u-space-p-10": props.fullPadding,
        "Content-children-inherit": props.color,
        "Content-flex": props.imageAlign === "left" || props.imageAlign === "right"
    });
    var containerStyles = {
        backgroundColor: props.bgColor && props.bgColor.length > 0 ? props.bgColor : null,
        color: props.color && props.color.length > 0 ? props.color : null
    };
    var imageClass = classnames_default()({
        "osm-u-float-left md-u-space-pr-10 lg-u-space-pr-10 Content-flex-first": props.imageAlign === "left",
        "osm-u-float-right md-u-space-pl-10 lg-u-space-pl-10 Content-flex-second": props.imageAlign === "right",
        "md-u-size-6of12 lg-u-size-6of12": (props.imageAlign === "left" || props.imageAlign === "right") && props.imageSize === "half",
        "md-u-size-4of12 lg-u-size-4of12": (props.imageAlign === "left" || props.imageAlign === "right") && props.imageSize === "1third",
        "md-u-size-8of12 lg-u-size-8of12": (props.imageAlign === "left" || props.imageAlign === "right") && props.imageSize === "2thirds"
    });
    var _obj;
    var textClass = classnames_default()((_obj = {
        "bd-hero-claim": isBricoStore
    }, TextImage_defineProperty(_obj, "osm-u-text-align-".concat(props.align), props.align !== "left"), TextImage_defineProperty(_obj, "osm-u-float-right md-u-space-pl-10 lg-u-space-pl-10 Content-flex-second", props.imageAlign === "left"), TextImage_defineProperty(_obj, "osm-u-float-left md-u-space-pr-10 lg-u-space-pr-10 Content-flex-first", props.imageAlign === "right"), TextImage_defineProperty(_obj, "md-u-size-6of12 lg-u-size-6of12", (props.imageAlign === "left" || props.imageAlign === "right") && props.imageSize === "half"), TextImage_defineProperty(_obj, "md-u-size-8of12 lg-u-size-8of12", (props.imageAlign === "left" || props.imageAlign === "right") && props.imageSize === "1third"), TextImage_defineProperty(_obj, "md-u-size-4of12 lg-u-size-4of12", (props.imageAlign === "left" || props.imageAlign === "right") && props.imageSize === "2thirds"), _obj));
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: containerClass,
        style: containerStyles,
        children: [
            props.imageAlign !== "topCenter" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                classNames: textClass,
                html: props.html
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentEditorView_Image, TextImage_objectSpread({}, props, {
                classNames: imageClass
            })),
            props.imageAlign === "topCenter" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                classNames: textClass,
                html: props.html
            })
        ]
    }));
};
/* harmony default export */ var ContentEditorView_TextImage = (TextImage);

;// CONCATENATED MODULE: ./components/ContentEditorView/Grid.js




function Grid_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var Grid = function(props) {
    var gridClass = classnames_default()("osm-u-grid", "osm-u-grid-2", Grid_defineProperty({
        "u-border-b-dotted": props.borderBottom,
        "u-border-t-dotted": props.borderTop,
        "u-space-mb-10 u-space-mt-10": props.verticalMargin,
        "u-space-pt-10 u-space-pb-10": props.verticalPadding,
        "u-space-p-10": props.fullPadding,
        "Content-children-inherit": props.color,
        "osm-u-grid--padding": props.columnSpacing,
        "Content-flex": props.verticalAlign
    }, "osm-u-grid-2--".concat(props.gridType), props.gridType !== "equal"));
    var gridStyles = {
        backgroundColor: props.bgColor && props.bgColor.length > 0 ? props.bgColor : null,
        color: props.color && props.color.length > 0 ? props.color : null
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: gridClass,
        style: gridStyles,
        children: props.children && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentEditorView_ContentEditorComponent, {
            content: props.children
        })
    }));
};
/* harmony default export */ var ContentEditorView_Grid = (Grid);

;// CONCATENATED MODULE: ./components/ContentEditorView/Column.js




var Column = function(props) {
    var columnClass = classnames_default()("osm-u-grid-col", "u-space-mt-0", {
        "u-space-p-20": props.fullPadding
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: columnClass,
        children: props.children && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentEditorView_ContentEditorComponent, {
            content: props.children
        })
    }));
};
/* harmony default export */ var ContentEditorView_Column = (Column);

// EXTERNAL MODULE: ./components/ContentEditorView/HtmlEmbed.js
var HtmlEmbed = __webpack_require__(96936);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./store/app/actions.js
var actions = __webpack_require__(27173);
;// CONCATENATED MODULE: ./components/ContentEditorView/StaticBlock.js




var StaticBlock = function(param) {
    var blockIdentifier = param.blockIdentifier, cmsBlocks = param.cmsBlocks, getCmsBlocks1 = param.getCmsBlocks;
    if (blockIdentifier) {
        getCmsBlocks1([
            blockIdentifier
        ]);
        if (cmsBlocks[blockIdentifier]) {
            // TODO: CMS blocks content should be migrated to Content Editor
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "Cms",
                dangerouslySetInnerHTML: {
                    __html: cmsBlocks[blockIdentifier]
                }
            }));
        }
    }
    // No data
    return null;
};
/* harmony default export */ var ContentEditorView_StaticBlock = ((0,es/* connect */.$j)(function(state) {
    return {
        cmsBlocks: state.app.cmsBlocks
    };
}, {
    getCmsBlocks: actions/* getCmsBlocks */.lD
})(StaticBlock));

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./components/Form/InputText.js + 2 modules
var InputText = __webpack_require__(58833);
// EXTERNAL MODULE: ./components/Alert.js + 10 modules
var Alert = __webpack_require__(16479);
// EXTERNAL MODULE: ./store/cms/constants.js
var constants = __webpack_require__(83897);
// EXTERNAL MODULE: ./lib/api/helpers.js
var helpers = __webpack_require__(45963);
// EXTERNAL MODULE: ./lib/api/index.js
var api = __webpack_require__(2642);
;// CONCATENATED MODULE: ./store/cms/actions.js



var submitContentEditorForm = function(values) {
    return function(dispatch, getState) {
        return (0,helpers/* makeApiCall */.Vo)({
            actions: {
                action: {
                    type: constants/* SUBMIT_CONTENT_EDITOR_FORM */.U0,
                    formName: values.formName
                },
                success: {
                    type: constants/* SUBMIT_CONTENT_EDITOR_FORM_SUCCESS */.oQ,
                    formName: values.formName
                },
                fail: {
                    type: constants/* SUBMIT_CONTENT_EDITOR_FORM_FAILURE */.x0,
                    formName: values.formName
                }
            },
            dispatch: dispatch,
            getState: getState,
            spinner: true,
            spinnerMessage: "Se trimite formularul...",
            alert: true,
            alertMessage: "Nu s-a putut trimite formularul. Te rugam incearca din nou mai tarziu.",
            apiCall: api/* submitContentEditorFormApi */.O4t,
            apiArgs: [
                values
            ],
            formatResponse: function(response) {
                return response.data;
            }
        });
    };
};

// EXTERNAL MODULE: ./components/Loading.js
var Loading = __webpack_require__(24461);
;// CONCATENATED MODULE: ./components/ContentEditorView/FormBlock.js










function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function FormBlock_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function FormBlock_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FormBlock_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var formItemTypes = [
    "checkboxInput",
    "radioGroup",
    "textareaInput",
    "submitInput",
    "textInput",
    "hiddenInput", 
];
var FormBlock = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(FormBlock, Component1);
    var _super = _createSuper(FormBlock);
    function FormBlock(props) {
        _classCallCheck(this, FormBlock);
        var _this;
        _this = _super.call(this, props);
        var _this1 = _assertThisInitialized(_this);
        FormBlock_defineProperty(_assertThisInitialized(_this), "handleFormSubmit", function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee(values) {
                var submitContentEditorForm1, response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            submitContentEditorForm1 = _this1.props.submitContentEditorForm;
                            _this1.setState({
                                isSending: true
                            });
                            _ctx.next = 4;
                            return submitContentEditorForm1({
                                formName: _this1.props.name,
                                formUrl: _this1.props.formUrl,
                                values: values
                            });
                        case 4:
                            response = _ctx.sent;
                            if (response) {
                                _this1.setState({
                                    isSending: false,
                                    isSent: true
                                });
                                // TODO: Fixed after package update
                                // https://github.com/final-form/final-form/issues/142
                                setTimeout(_this1.formReset, 100);
                            } else {
                                _this1.setState({
                                    isSent: false,
                                    isSending: false
                                });
                            }
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }());
        FormBlock_defineProperty(_assertThisInitialized(_this), "getInitialValues", function() {
            var initialValues = {};
            _this.props.children// Filter form items
            .filter(function(item) {
                return formItemTypes.includes(item.type);
            })// Filter elements which don't contain default values
            // or are not radio groups
            .filter(function(formItem) {
                return formItem.type === "radioGroup" || formItem.content.value;
            }).forEach(function(formItem) {
                // For radio groups, first radio input is default value
                if (formItem.type === "radioGroup" && formItem.blocks.length > 0) {
                    return initialValues["".concat(formItem.content.name)] = formItem.blocks[0].content.label;
                }
                return initialValues["".concat(formItem.content.name)] = formItem.content.value;
            });
            return initialValues;
        });
        _this.formReset = undefined;
        _this.state = {
            isSending: false,
            isSent: false
        };
        return _this;
    }
    _createClass(FormBlock, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, name = _props.name, children = _props.children, formUrl = _props.formUrl;
                var _state = this.state, isSent = _state.isSent, isSending = _state.isSending;
                // TODO: THIS IS NOT RIGHT!
                // FUNCTIONALITY WILL BREAK IF GW SUBDOMAINS CHANGE!!!!!
                var isXHR = formUrl.includes("fenrir") || formUrl.includes("cerberus");
                // if (this.props.valid) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "js-cms-form u-space-mt-10 u-space-mb-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
                            onSubmit: this.handleFormSubmit,
                            initialValues: this.getInitialValues(),
                            render: function(param) {
                                var form = param.form, handleSubmit = param.handleSubmit;
                                _this.formReset = form.reset;
                                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("form", FormBlock_objectSpread({}, isXHR && {
                                    onSubmit: handleSubmit
                                }, !isXHR && {
                                    method: "post",
                                    action: formUrl
                                }, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                            component: InputText/* default */.Z,
                                            id: name,
                                            name: name,
                                            type: "hidden"
                                        }),
                                        children && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentEditorView_ContentEditorComponent, {
                                            content: children
                                        })
                                    ]
                                })));
                            }
                        }),
                        isSending && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
                            height: 80,
                            children: "Se trimite"
                        }),
                        isSent && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "u-space-mb-20 u-text-align-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                                type: "success",
                                showIcon: true,
                                children: "Formularul a fost trimis."
                            })
                        })
                    ]
                }));
            // }
            // // Invalid component
            // return null;
            }
        }
    ]);
    return FormBlock;
}(react.Component);
/* harmony default export */ var ContentEditorView_FormBlock = ((0,es/* connect */.$j)(null, {
    submitContentEditorForm: submitContentEditorForm
})(FormBlock));

;// CONCATENATED MODULE: ./components/ContentEditorView/HiddenInput.js




var HiddenInput = function(props) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
        component: InputText/* default */.Z,
        id: props.name,
        name: props.name,
        type: "hidden"
    });
};
/* harmony default export */ var ContentEditorView_HiddenInput = (HiddenInput);

// EXTERNAL MODULE: ./lib/validations.js + 1 modules
var validations = __webpack_require__(38294);
;// CONCATENATED MODULE: ./components/ContentEditorView/TextInput.js





var validationsMap = {
    required: validations/* isRequired */.q9,
    vnumberSpace: validations/* isNumberAndSpaces */.fZ,
    vnumber: validations/* isNumber */.hj,
    valphanumeric: validations/* isAlphaNumeric */.bJ,
    vemail: validations/* isEmail */.Jh,
    vname: validations/* isAlphaNumeric */.bJ,
    vphone: validations/* isPhoneNumber */.xT
};
var TextInput = function(props) {
    // if (props.valid) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
        id: props.name,
        name: props.name,
        label: props.label,
        component: InputText/* default */.Z,
        type: "text",
        required: props.required,
        validate: (0,validations/* composeFormValidators */.JT)(props.required ? validationsMap["required"]() : function() {
            return undefined;
        }, props.validation ? validationsMap[props.validationRules]() : function() {
            return undefined;
        })
    }));
// }
// Invalid component
// return null;
};
/* harmony default export */ var ContentEditorView_TextInput = (TextInput);

// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
;// CONCATENATED MODULE: ./components/ContentEditorView/SubmitInput.js



var SubmitInput = function(props) {
    if (props.valid) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            type: "submit",
            title: props.label,
            size: "normal",
            variant: "primary",
            classesProp: "js-trigger-save"
        }));
    }
    // Invalid component
    return null;
};
/* harmony default export */ var ContentEditorView_SubmitInput = (SubmitInput);

// EXTERNAL MODULE: ./components/Form/Textarea.js
var Textarea = __webpack_require__(4792);
;// CONCATENATED MODULE: ./components/ContentEditorView/TextareaInput.js





var TextareaInput = function(props) {
    if (props.valid) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
            id: props.name,
            name: props.name,
            label: props.label,
            component: Textarea/* default */.Z,
            type: "text",
            required: props.required,
            validate: props.required ? (0,validations/* isRequired */.q9)() : function() {
                return undefined;
            }
        }));
    }
    // Invalid component
    return null;
};
/* harmony default export */ var ContentEditorView_TextareaInput = (TextareaInput);

// EXTERNAL MODULE: ./components/Form/Checkbox.js
var Checkbox = __webpack_require__(71662);
;// CONCATENATED MODULE: ./components/ContentEditorView/CheckboxInput.js





var CheckboxInput = function(props) {
    if (props.valid) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
            id: props.name,
            name: props.name,
            component: Checkbox/* default */.Z,
            label: props.label,
            type: "checkbox",
            required: props.required,
            validate: props.required ? (0,validations/* isRequired */.q9)() : function() {
                return undefined;
            }
        }));
    }
    // Invalid component
    return null;
};
/* harmony default export */ var ContentEditorView_CheckboxInput = (CheckboxInput);

// EXTERNAL MODULE: ./components/Form/Radio.js
var Radio = __webpack_require__(13890);
;// CONCATENATED MODULE: ./components/ContentEditorView/RadioInput.js




var RadioInput = function(props) {
    if (props.valid) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
            id: props.label,
            value: props.label,
            name: props.name,
            component: Radio/* default */.Z,
            label: props.label,
            type: "radio"
        }));
    }
    // Invalid component
    return null;
};
/* harmony default export */ var ContentEditorView_RadioInput = (RadioInput);

;// CONCATENATED MODULE: ./components/ContentEditorView/RadioGroup.js



function RadioGroup_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RadioGroup_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RadioGroup_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var RadioGroup = function(props) {
    var radioButtons = props.children.map(function(child) {
        return RadioGroup_objectSpread({}, child, {
            content: RadioGroup_objectSpread({}, child.content, {
                name: props.name
            })
        });
    });
    if (props.valid) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "u-space-mb-5 u-space-mt-5",
            children: [
                props.label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    className: "Form-label",
                    children: typeof props.label === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: props.label
                        },
                        className: "inline-block"
                    }) : props.label
                }),
                radioButtons.map(function(radioButton, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ContentEditorView_ContentEditorComponent, {
                        content: [
                            radioButton
                        ]
                    }, index);
                })
            ]
        }));
    }
    // Invalid component
    return null;
};
/* harmony default export */ var ContentEditorView_RadioGroup = (RadioGroup);

// EXTERNAL MODULE: ./components/Modal.js
var Modal = __webpack_require__(12280);
;// CONCATENATED MODULE: ./components/ContentEditorView/ModalBlock.js







var ModalBlock = function(param) {
    var alignCenter = param.alignCenter, buttonTitle = param.buttonTitle, id = param.id, children = param.children, addModal1 = param.addModal;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: alignCenter ? "u-text-align-center" : "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    onClick: function() {
                        return addModal1(id);
                    },
                    title: buttonTitle,
                    size: "normal",
                    variant: "primary",
                    classesProp: "js-cms-modal"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                id: id,
                header: buttonTitle,
                children: children && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentEditorView_ContentEditorComponent, {
                    content: children
                })
            })
        ]
    });
};
/* harmony default export */ var ContentEditorView_ModalBlock = ((0,es/* connect */.$j)(null, {
    addModal: actions/* addModal */.Y_
})(ModalBlock));

// EXTERNAL MODULE: ./lib/helpers.js
var lib_helpers = __webpack_require__(15722);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./components/Lightbox.js




var Lightbox = function(param) {
    var active = param.active, title = param.title, children = param.children, onCloseRequest = param.onCloseRequest;
    var ref = (0,react.useState)(null), /*#__PURE__*/ isReady = ref[0], setIsReady = ref[1];
    var ref1 = (0,react.useState)(null), isOpen = ref1[0], setIsOpen = ref1[1];
    (0,react.useEffect)(function() {
        setIsReady(true);
        setIsOpen(true);
    }, []);
    var handleContentAreaClick = function(event) {
        event.preventDefault();
        // Request lightbox close when
        // clicking lightbox content but not on content
        if (event.target === event.currentTarget) {
            onCloseRequest();
        }
    };
    var renderChildren = function() {
        // Clone each child and pass onCloseRequest props
        return react.Children.map(children, function(child) {
            return(/*#__PURE__*/ (0,react.cloneElement)(child, {
                onCloseRequest: onCloseRequest
            }));
        });
    };
    return active && isReady && isOpen && /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-e6f03b42bbcc67eb" + " " + "fixed top-0 left-0 flex flex-col items-center justify-center bg-white w-full h-full z-[3000] ".concat(title ? "lightbox-container-with-title" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: onCloseRequest,
                className: "jsx-e6f03b42bbcc67eb" + " " + "fixed top-20px right-20px cursor-pointer p-1.5 z-50",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "30",
                    height: "30",
                    className: "jsx-e6f03b42bbcc67eb",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        stroke: "rgb(0, 0, 0)",
                        strokeWidth: "4",
                        className: "jsx-e6f03b42bbcc67eb",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                x1: "5",
                                y1: "5",
                                x2: "25",
                                y2: "25",
                                className: "jsx-e6f03b42bbcc67eb"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                x1: "5",
                                y1: "25",
                                x2: "25",
                                y2: "5",
                                className: "jsx-e6f03b42bbcc67eb"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: handleContentAreaClick,
                className: "jsx-e6f03b42bbcc67eb" + " " + "flex flex-grow  justify-center w-full overflow-y-auto",
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-e6f03b42bbcc67eb" + " " + "absolute w-full bottom-0 left-0 bg-black bg-opacity-90 text-13px font-bold leading-normal text-center text-gray-text",
                        children: title
                    }),
                    renderChildren()
                ]
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "e6f03b42bbcc67eb",
                children: "html, body{overflow:hidden}"
            })
        ]
    }), document.body);
};
// TODO: Find a way to replace the body style from jsx to tailwind
/* harmony default export */ var components_Lightbox = (Lightbox);

// EXTERNAL MODULE: ./components/ProductMedia/InLightboxGallery.js
var InLightboxGallery = __webpack_require__(51425);
;// CONCATENATED MODULE: ./components/ContentEditorView/GalleryBlock.js






var GalleryBlock = function(param) {
    var picked = param.picked, alignCenter = param.alignCenter;
    var ref = (0,react.useState)(0), currentGallerySlide = ref[0], setCurrentGallerySlide = ref[1];
    var ref1 = (0,react.useState)(false), isLightboxOpen = ref1[0], setIsLightboxOpen = ref1[1];
    var images = picked.map(function(image) {
        return {
            file: "".concat(image.path).concat(image.name)
        };
    });
    var galleryClass = classnames_default()("js-cms-gallery", {
        "u-text-align-center": alignCenter
    });
    var toggleLightbox = function() {
        setIsLightboxOpen(!isLightboxOpen);
    };
    var handleImageClick = function(event, index) {
        event.preventDefault();
        setCurrentGallerySlide(index);
        setIsLightboxOpen(true);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: galleryClass,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "List List--inline List--noMargin",
                    children: images.map(function(image, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "u-display-block u-border-solid",
                                href: "#",
                                onClick: function(event) {
                                    return handleImageClick(event, index);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "u-display-block",
                                    src: (0,lib_helpers/* resizeImage */.tg)(image.file, "100x100"),
                                    width: 100,
                                    height: 100,
                                    alt: ""
                                })
                            })
                        }, image.file);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Lightbox, {
                active: isLightboxOpen,
                onCloseRequest: toggleLightbox,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InLightboxGallery/* default */.Z, {
                    title: "",
                    images: images,
                    currentSlide: currentGallerySlide,
                    onSlideChange: setCurrentGallerySlide,
                    inLightbox: true
                })
            })
        ]
    }));
};
/* harmony default export */ var ContentEditorView_GalleryBlock = (GalleryBlock);

// EXTERNAL MODULE: ./components/ProductList/index.js + 2 modules
var ProductList = __webpack_require__(75866);
// EXTERNAL MODULE: ./store/catalog/actions.js
var catalog_actions = __webpack_require__(35493);
// EXTERNAL MODULE: ./store/tracker/actions.js + 1 modules
var tracker_actions = __webpack_require__(48712);
;// CONCATENATED MODULE: ./components/ContentEditorView/ProductsBlock.js








function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function ProductsBlock_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function ProductsBlock_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ProductsBlock_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ProductsBlock_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ProductsBlock_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ProductsBlock_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function ProductsBlock_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function ProductsBlock_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) ProductsBlock_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) ProductsBlock_defineProperties(Constructor, staticProps);
    return Constructor;
}
function ProductsBlock_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductsBlock_getPrototypeOf(o) {
    ProductsBlock_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return ProductsBlock_getPrototypeOf(o);
}
function ProductsBlock_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) ProductsBlock_setPrototypeOf(subClass, superClass);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ProductsBlock_possibleConstructorReturn(self, call) {
    if (call && (ProductsBlock_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return ProductsBlock_assertThisInitialized(self);
}
function ProductsBlock_setPrototypeOf(o, p) {
    ProductsBlock_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return ProductsBlock_setPrototypeOf(o, p);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var ProductsBlock_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function ProductsBlock_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function ProductsBlock_createSuper(Derived) {
    var hasNativeReflectConstruct = ProductsBlock_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = ProductsBlock_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = ProductsBlock_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return ProductsBlock_possibleConstructorReturn(this, result);
    };
}
var ProductsBlock = /*#__PURE__*/ function(Component1) {
    "use strict";
    ProductsBlock_inherits(ProductsBlock, Component1);
    var _super = ProductsBlock_createSuper(ProductsBlock);
    function ProductsBlock(props) {
        ProductsBlock_classCallCheck(this, ProductsBlock);
        var _this;
        _this = _super.call(this, props);
        var _this1 = ProductsBlock_assertThisInitialized(_this);
        ProductsBlock_defineProperty(ProductsBlock_assertThisInitialized(_this), "loadProductsData", ProductsBlock_asyncToGenerator(runtime_default().mark(function _callee() {
            var productSkus, products, sortedProducts;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        productSkus = _this1.props.products.split(",").map(function(productSku) {
                            return productSku.trim();
                        });
                        _ctx.next = 3;
                        return _this1.props.getProductsBySku(productSkus);
                    case 3:
                        products = _ctx.sent;
                        sortedProducts = _toConsumableArray(products).sort(function(a, b) {
                            return productSkus.indexOf(a.sku) > productSkus.indexOf(b.sku) ? 1 : -1;
                        });
                        _this1.setState({
                            isLoading: false,
                            productsData: sortedProducts
                        });
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })));
        ProductsBlock_defineProperty(ProductsBlock_assertThisInitialized(_this), "handleProductClick", function(product) {
            // Track product click
            _this.props.trackProductClick(product);
        });
        _this.state = {
            productsData: [],
            isLoading: true
        };
        return _this;
    }
    ProductsBlock_createClass(ProductsBlock, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.valid && this.props.products && this.props.products.length > 0) {
                    this.loadProductsData();
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _state = this.state, productsData = _state.productsData, isLoading = _state.isLoading;
                if (!isLoading && productsData && productsData.length > 0) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ContentEditorView-ProductsBlock",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList/* default */.Z, {
                                    products: productsData,
                                    containerClass: "flex flex-wrap Products--".concat(this.props.columns, "to2"),
                                    onProductClick: this.handleProductClick,
                                    listType: "contentEditor"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                                children: "\n            .ContentEditorView-ProductsBlock .Product-nameHeading {\n              text-transform: none;\n              font-size: 13px;\n              letter-spacing: inherit;\n              font-size: 13px;\n              line-height: 18px;\n              font-weight: 400;\n              margin: 5px 0;\n            }\n\n            .ContentEditorView-ProductsBlock .Product-name {\n              color: #595857;\n            }\n          "
                            })
                        ]
                    }));
                }
                if (isLoading) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
                        height: 120,
                        children: "Se incarca produsele"
                    }));
                }
                // No data
                return null;
            }
        }
    ]);
    return ProductsBlock;
}(react.Component);
ProductsBlock.defaultProps = {
    columns: 5,
    products: []
};
/* harmony default export */ var ContentEditorView_ProductsBlock = ((0,es/* connect */.$j)(null, {
    getProductsBySku: catalog_actions/* getProductsBySku */.uX,
    trackProductClick: tracker_actions/* trackProductClick */.Cg
})(ProductsBlock));

// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(23493);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
;// CONCATENATED MODULE: ./components/Gallery360.js





function Gallery360_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function Gallery360_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function Gallery360_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function Gallery360_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) Gallery360_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) Gallery360_defineProperties(Constructor, staticProps);
    return Constructor;
}
function Gallery360_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Gallery360_getPrototypeOf(o) {
    Gallery360_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return Gallery360_getPrototypeOf(o);
}
function Gallery360_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Gallery360_setPrototypeOf(subClass, superClass);
}
function Gallery360_possibleConstructorReturn(self, call) {
    if (call && (Gallery360_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return Gallery360_assertThisInitialized(self);
}
function Gallery360_setPrototypeOf(o, p) {
    Gallery360_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return Gallery360_setPrototypeOf(o, p);
}
var Gallery360_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function Gallery360_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function Gallery360_createSuper(Derived) {
    var hasNativeReflectConstruct = Gallery360_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = Gallery360_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = Gallery360_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return Gallery360_possibleConstructorReturn(this, result);
    };
}
var Gallery360 = /*#__PURE__*/ function(Component1) {
    "use strict";
    Gallery360_inherits(Gallery360, Component1);
    var _super = Gallery360_createSuper(Gallery360);
    function Gallery360(props) {
        Gallery360_classCallCheck(this, Gallery360);
        var _this;
        _this = _super.call(this, props);
        Gallery360_defineProperty(Gallery360_assertThisInitialized(_this), "enableGallery", function() {
            _this.setState({
                userEnabled: true
            });
        });
        Gallery360_defineProperty(Gallery360_assertThisInitialized(_this), "handleMove", function(event) {
            event.preventDefault();
            var pointerPosition = _this.calculatePointerPosition(event);
            var max = event.currentTarget.offsetWidth;
            var offset = pointerPosition - _this.state.currentSlide;
            var delta = Math.floor(offset / max * _this.props.children.length);
            // Prevent negative slide
            var newSlide = delta > 0 ? delta : 0;
            if (_this.state.currentSlide !== newSlide) {
                _this.setState({
                    currentSlide: newSlide
                });
            }
        });
        _this.state = {
            currentSlide: 0,
            userEnabled: false
        };
        _this.throttledHandleMove = throttle_default()(_this.handleMove, 100, {
            trailing: false
        });
        return _this;
    }
    Gallery360_createClass(Gallery360, [
        {
            key: "calculatePointerPosition",
            /*#__PURE__*/ value: function calculatePointerPosition(event) {
                var clientX = (event.type.indexOf("touch") === 0 ? event.changedTouches[0] : event).clientX;
                var position = clientX - event.currentTarget.offsetLeft;
                // Prevent negative position
                return position > 0 ? position : 0;
            }
        },
        {
            key: "render",
            value: function render() {
                if (Array.isArray(this.props.children) && this.props.children.length > 0) {
                    var _this = this;
                    // 360 not enabled
                    if (!this.state.userEnabled) {
                        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat(this.props.className || "", " u-position-relative u-text-align-center"),
                            onClick: this.enableGallery,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "rollerblade-icon"
                                }),
                                this.props.children[0]
                            ]
                        }));
                    }
                    // 360 enabled
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onTouchMove: this.throttledHandleMove,
                        onMouseMove: this.throttledHandleMove,
                        className: "jsx-a3b896d6697e47fd" + " " + "".concat(this.props.className || "", " u-position-relative u-text-align-center gallery360"),
                        children: [
                            react.Children.map(this.props.children, function(child, index) {
                                /*#__PURE__*/ return (0,react.cloneElement)(child, {
                                    className: "gallery360-image",
                                    style: {
                                        display: _this.state.currentSlide === index ? "block" : "none"
                                    }
                                });
                            }),
                            (0,jsx_runtime.jsx)((style_default()), {
                                id: "a3b896d6697e47fd",
                                children: ".gallery360-image{margin:0 auto}"
                            })
                        ]
                    }));
                }
                return null;
            }
        }
    ]);
    return Gallery360;
}(react.Component);
Gallery360.propTypes = {
    className: (prop_types_default()).string,
    children: prop_types_default().arrayOf((prop_types_default()).element).isRequired
};
/* harmony default export */ var components_Gallery360 = (Gallery360);

;// CONCATENATED MODULE: ./components/ContentEditorView/Image360.js




var Image360_ref = (0,config["default"])(), Image360_settings = Image360_ref.publicRuntimeConfig.settings;
var Image360 = function(param) {
    var picked = param.picked;
    if (picked && picked.length > 0) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_Gallery360, {
            children: picked.map(function(image) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("img", {
                    src: "".concat(Image360_settings.cdn).concat(image.path).concat(image.name)
                }, image.name);
            })
        }));
    }
    return null;
};
/* harmony default export */ var ContentEditorView_Image360 = (Image360);

;// CONCATENATED MODULE: ./components/ContentEditorView/ContentEditorComponent.js
























function ContentEditorComponent_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ContentEditorComponent_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ContentEditorComponent_arrayLikeToArray(arr);
}
function ContentEditorComponent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ContentEditorComponent_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ContentEditorComponent_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ContentEditorComponent_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ContentEditorComponent_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ContentEditorComponent_toConsumableArray(arr) {
    return ContentEditorComponent_arrayWithoutHoles(arr) || ContentEditorComponent_iterableToArray(arr) || ContentEditorComponent_unsupportedIterableToArray(arr) || ContentEditorComponent_nonIterableSpread();
}
function ContentEditorComponent_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ContentEditorComponent_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ContentEditorComponent_arrayLikeToArray(o, minLen);
}
var componentMap = {
    section: ContentEditorView_Section,
    checkboxInput: ContentEditorView_CheckboxInput,
    column: ContentEditorView_Column,
    form: ContentEditorView_FormBlock,
    gallery: ContentEditorView_GalleryBlock,
    grid: ContentEditorView_Grid,
    hiddenInput: ContentEditorView_HiddenInput,
    htmlEmbed: HtmlEmbed/* default */.Z,
    image: ContentEditorView_Image,
    imageSlider: ContentEditorView_Image360,
    medium: ContentEditorView_Medium,
    modal: ContentEditorView_ModalBlock,
    products: ContentEditorView_ProductsBlock,
    radioGroup: ContentEditorView_RadioGroup,
    radioInput: ContentEditorView_RadioInput,
    textareaInput: ContentEditorView_TextareaInput,
    staticBlock: ContentEditorView_StaticBlock,
    submitInput: ContentEditorView_SubmitInput,
    textInput: ContentEditorView_TextInput,
    textimage: ContentEditorView_TextImage,
    youtube: ContentEditorView_YouTube
};
var parseContentTree = function(item, index) {
    var Component = componentMap[item.type];
    var componentProps = ContentEditorComponent_objectSpread({}, item.content, {
        children: ContentEditorComponent_toConsumableArray(item.blocks)
    });
    return Component && /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, ContentEditorComponent_objectSpread({}, componentProps), index);
};
var ContentEditorComponent = function(param) {
    var content = param.content;
    if (Array.isArray(content) && content.length > 0) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: content// Show only items with type defined
            .filter(function(item) {
                return item.type;
            })// Parse content
            .map(function(item, index) {
                return parseContentTree(item, index);
            })
        }));
    }
    // No data provided
    return null;
};
ContentEditorComponent.propTypes = {
    content: prop_types_default().arrayOf((prop_types_default()).object).isRequired
};
/* harmony default export */ var ContentEditorView_ContentEditorComponent = (ContentEditorComponent);

;// CONCATENATED MODULE: ./components/ContentEditorView/index.js




var ContentEditorView = function(param) {
    var content = param.content;
    if (Array.isArray(content) && content.length > 0) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ContentEditorView_ContentEditorComponent, {
            content: content
        }));
    }
    // No data provided
    return null;
};
ContentEditorView.propTypes = {
    content: prop_types_default().arrayOf((prop_types_default()).object).isRequired
};
/* harmony default export */ var components_ContentEditorView = (ContentEditorView);


/***/ }),

/***/ 13890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var InputRadio = function(props) {
    var input = props.input, _meta = props.meta, touched = _meta.touched, error = _meta.error;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
            className: "Form-checkbox flex items-center ".concat(props.className ? props.className : "", " ").concat(props.disabled ? "disabled" : ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({}, input, {
                    id: props.id,
                    type: "radio",
                    disabled: props.disabled,
                    className: "checkbox-input opacity-0 w-0 h-0 ".concat(touched && error ? "error" : "")
                })),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "checkbox-control is-radio flex-none w-5 h-5 p-1 mr-2 border-gray-1600 hover:border-black border rounded-full bg-white ".concat(props.required ? "is-required" : ""),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        width: "10",
                        height: "10",
                        viewBox: "0 0 10 10",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "10",
                            height: "10",
                            rx: "5",
                            fill: "#319D10"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "inline-block leading-18.2 ".concat(props.labelClass),
                    children: typeof props.label === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: props.label
                        },
                        className: "inline-block"
                    }) : props.label
                })
            ]
        })
    }));
};
InputRadio.defaultProps = {
    disabled: undefined
};
/* harmony default export */ __webpack_exports__["Z"] = (InputRadio);


/***/ }),

/***/ 4792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Textarea = function(props) {
    var input = props.input, children = props.children, rows = props.rows, _meta = props.meta, touched = _meta.touched, error = _meta.error;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-between items-center",
                children: props.label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                    htmlFor: props.id,
                    className: "Form-label ".concat(props.required ? "is-required" : "", " ").concat(props.disabled ? "disabled" : "", " ").concat(props.labelClass),
                    children: typeof props.label === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: props.label
                        },
                        className: "inline-block"
                    }) : props.label
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", _objectSpread({}, input, {
                required: props.required,
                disabled: props.disabled,
                placeholder: props.placeholder,
                autoCorrect: props.autoCorrect,
                rows: rows,
                className: props.className ? "".concat(props.className, " ").concat(touched && error ? "error" : "") : "w-full text-black ".concat(props.inputClassName, " ").concat(touched && error ? "error" : ""),
                children: children
            })),
            touched && error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-red-brand text-sm",
                children: error
            })
        ]
    }));
};
Textarea.defaultProps = {
    id: undefined,
    label: undefined,
    required: undefined,
    disabled: undefined,
    placeholder: undefined,
    rows: undefined,
    autoCorrect: undefined
};
/* harmony default export */ __webpack_exports__["Z"] = (Textarea);


/***/ }),

/***/ 57153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);


var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_1__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var CarouselNavArrow = function(param) {
    var direction = param.direction;
    var rotation = {
        up: "rotate-90",
        down: "-rotate-90",
        left: "",
        right: "-rotate-180"
    }[direction];
    return websiteName === "bricostore" ? // Material Design "chevron_left" (24x24, Apache-2.0) — base points left like the original. Color via fill-current.
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: "transform fill-current ".concat(rotation),
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59Z"
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: "transform ".concat(rotation),
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M22 14L17.334 19.1158C16.8887 19.604 16.8887 20.396 17.334 20.8842L22 26",
            stroke: "black",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CarouselNavArrow);


/***/ }),

/***/ 51425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15722);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2261);
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66832);
/* harmony import */ var _components_Icons_CarouselNavArrow__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57153);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25194);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper_css_zoom__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80615);
/* harmony import */ var swiper_css_zoom__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css_zoom__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18700);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11752);










var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_9__["default"])(), settings = ref.publicRuntimeConfig.settings;
var InLightboxGallery = function(param1) {
    var images = param1.images, title = param1.title, onSlideClick = param1.onSlideClick, onSlideChange = param1.onSlideChange, currentSlide = param1.currentSlide;
    var singleSlide = images.length <= 1;
    var mainSwiper = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), thumbsSwiper = ref6[0], setThumbsSwiper = ref6[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isBeginning1 = ref1[0], setIsBeginning = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isEnd1 = ref2[0], setIsEnd = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), prevEl = ref3[0], setPrevEl = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), nextEl = ref4[0], setNextEl = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isZoomed = ref5[0], setIsZoomed = ref5[1];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col-reverse sm:flex-row justify-around w-full relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "sm:pl-[20px] flex flex-col",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mx-auto mb-[6px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-sm md:text-base font-normal md:font-medium",
                            children: "".concat(currentSlide + 1, " din ").concat(images.length)
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .tq, {
                        className: "w-full px-[15px] sm:px-0 mx-auto sm:mx-0",
                        direction: "vertical",
                        onSwiper: function(swiper) {
                            setThumbsSwiper(swiper);
                        },
                        loop: false,
                        initialSlide: currentSlide,
                        modules: [
                            swiper_modules__WEBPACK_IMPORTED_MODULE_4__/* .Navigation */ .W_,
                            swiper_modules__WEBPACK_IMPORTED_MODULE_4__/* .Thumbs */ .o3
                        ],
                        onSlideChange: function(param) {
                            var isBeginning = param.isBeginning, isEnd = param.isEnd;
                            setIsBeginning(isBeginning);
                            setIsEnd(isEnd);
                        },
                        breakpoints: {
                            0: {
                                direction: "horizontal",
                                slidesPerView: 4,
                                slidesPerGroup: 3,
                                spaceBetween: 6
                            },
                            640: {
                                direction: "vertical",
                                slidesPerView: "auto",
                                slidesPerGroup: 3,
                                spaceBetween: 10
                            }
                        },
                        children: images.map(function(image, index) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .SwiperSlide */ .o5, {
                                className: "h-full min-w-[80px] sm:!h-[80px] sm:w-[80px]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "p-2 md:p-2.5 flex justify-center border rounded-bl-lg rounded-tr-lg cursor-pointer select-none ".concat(currentSlide === index ? "border-yellow" : "border-gray-900"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: (0,_lib_helpers__WEBPACK_IMPORTED_MODULE_2__/* .resizeImage */ .tg)(image.file, "80x80"),
                                        className: "block aspect-square object-contain select-none",
                                        alt: ""
                                    })
                                })
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .tq, {
                className: "w-full sm:w-[calc(100%-120px)] relative sm:ml-20px",
                ref: mainSwiper,
                initialSlide: currentSlide,
                slidesPerView: 1,
                spaceBetween: 10,
                loop: false,
                keyboard: true,
                thumbs: {
                    swiper: thumbsSwiper
                },
                modules: [
                    swiper_modules__WEBPACK_IMPORTED_MODULE_4__/* .FreeMode */ .Rv,
                    swiper_modules__WEBPACK_IMPORTED_MODULE_4__/* .Thumbs */ .o3,
                    swiper_modules__WEBPACK_IMPORTED_MODULE_4__/* .Zoom */ .LG,
                    swiper_modules__WEBPACK_IMPORTED_MODULE_4__/* .Navigation */ .W_,
                    swiper_modules__WEBPACK_IMPORTED_MODULE_4__/* .Keyboard */ .N1
                ],
                onRealIndexChange: function(param) {
                    var zoom = param.zoom, realIndex = param.realIndex;
                    zoom.out();
                    onSlideChange(realIndex);
                },
                onSlideChange: function(param) {
                    var isBeginning = param.isBeginning, isEnd = param.isEnd;
                    setIsBeginning(isBeginning);
                    setIsEnd(isEnd);
                },
                navigation: {
                    nextEl: nextEl,
                    prevEl: prevEl
                },
                zoom: {
                    maxRatio: 2
                },
                onClick: function(swiper) {
                    swiper.zoom.toggle();
                    setIsZoomed(!isZoomed);
                },
                children: [
                    images.map(function(image, index) {
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .SwiperSlide */ .o5, {
                            className: "".concat(isZoomed ? "!cursor-zoom-out" : "!cursor-zoom-in"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "swiper-zoom-container mx-auto aspect-square w-full",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    onClick: onSlideClick,
                                    src: "".concat(settings.cdn).concat(image.file),
                                    alt: title
                                })
                            })
                        }, index);
                    }),
                    !singleSlide && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "hidden sm:block absolute left-[20px] z-10 top-[50%]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PreviousButton, {
                                    setPrevEl: setPrevEl,
                                    isBeginning: isBeginning1
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "hidden sm:block absolute right-[20px] z-10 top-[50%]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NextButton, {
                                    setNextEl: setNextEl,
                                    isEnd: isEnd1
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
var PreviousButton = function(param) {
    var setPrevEl = param.setPrevEl, isBeginning = param.isBeginning;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: function(node) {
            return setPrevEl(node);
        },
        className: "w-8 h-8 md:w-10 md:h-10 rounded-full bg-gray-1300 ".concat(isBeginning ? "opacity-50 cursor-default" : "opacity-90 cursor-pointer"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Icons_CarouselNavArrow__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
    });
};
var NextButton = function(param) {
    var setNextEl = param.setNextEl, isEnd = param.isEnd;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: function(node) {
            return setNextEl(node);
        },
        className: "w-8 h-8 md:w-10 md:h-10 rounded-full bg-gray-1300 ".concat(isEnd ? "opacity-50 cursor-default" : "opacity-90 cursor-pointer"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Icons_CarouselNavArrow__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            direction: "right"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InLightboxGallery);


/***/ }),

/***/ 80615:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);